import { useConfig } from "@/config.ts";
import { DigioBaValidationBlock } from "@/modules/billing/account_validation/digio/DigioBaValidationBlock.tsx";
import { GeneralBaValidationBlock } from "@/modules/billing/account_validation/GeneralBaValidationBlock.tsx";
import type { EBillingAccount } from "@/modules/billing/billingLogic.tsx";
import { Trans } from "@lingui/react/macro";

export function BillingAccountValidationBlock({ billing_account }: { billing_account: EBillingAccount }) {
    const { billingAccountValidation } = useConfig();
    if (billingAccountValidation?.process === "EXTERNAL") {
        switch (billingAccountValidation?.provider) {
            case "digio":
                return <DigioBaValidationBlock config={billingAccountValidation} billing_account={billing_account} />;
            default:
                return (
                    <GeneralBaValidationBlock
                        description={<Trans>An e-mail with instructions has been sent to you.</Trans>}
                    />
                );
        }
    } else if (billingAccountValidation?.process === "MANUAL") {
        return <GeneralBaValidationBlock title={<Trans>Account details are being validated.</Trans>} />;
    }
}
